// Centralised Recharts visual tokens. Import these everywhere — never hardcode
// chart colors per file.

export const CHART_COLORS = [
  '#FF0034', // brand red
  '#19D5F1', // brand cyan
  '#FFB020', // warning amber
  '#FF0046', // red highlight
  '#6D6D6D', // muted (use for "other")
] as const;

export const CHART_AXIS = {
  stroke: 'rgba(255,255,255,0.15)', // surface.divider
  tick: {
    fill: '#CCCCCC', // fg.muted
    fontSize: 12,
    fontFamily: 'Tommy, system-ui, sans-serif',
  },
} as const;

export const CHART_TOOLTIP_STYLE = {
  background: '#0F1215',
  border: '1px solid rgba(255,255,255,0.15)',
  borderRadius: 14,
  fontSize: 14,
  color: '#FFFFFF',
  fontFamily: 'Tommy, system-ui, sans-serif',
  padding: '8px 12px',
} as const;

export const CHART_TOOLTIP_ITEM_STYLE = {
  color: '#FFFFFF',
} as const;
